import breakpoints from '../../theme/breakpoints'
import redesignedTheme from '../../theme/news12-redesign'

import css from 'styled-jsx/css'

export default css.global`
  .projects-container {
    max-width: 800px;
    margin: 0 auto;
  }
  
  .full-width, .image {
    width: 100vw;
    position: relative;
    left: 50%;
    right: 50%;
    margin-left: -50vw;
    margin-right: -50vw;
  }
  
  .image>img {
    width: 100%;
  }
  
  .projects-container h2 {
    font-size: 25px;
    font-weight: 500;
    line-weight: 1.3;
    border: none;
    font-style: normal;
  }
  
  .block-quote {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    text-align: center;
    font-weight: 500;
    gap: 30px;
    font-size: 30px;
    line-height: 125%;
    margin: 12px 0;
  }
  
  .quote {
    height: 3em;
  }
  
  .projects-container blockquote {
    margin: 0 0 36px 0;
    padding: 5px 0px 5px 40px;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .projects-container blockquote:before {
    content: "";
    height: 100%;
    width: 24px;
    background: ${redesignedTheme.colors.lightBlue};
    position: absolute;
    left: 0;
  }
  
  .projects-container blockquote > p {
    font-weight: 500;
    font-size: 28px;
    line-height: 38px;
    color: ${redesignedTheme.colors.mineShaft};
    margin: 0;
  }
  
  .projects-container p, .block, .block i {
    font-weight: 300;
    margin: 18px 0;
  }
  
  .projects-container div.embed {
    margin: 0 auto 30px auto;
    max-width: 100%;
  }
  
  .facebook-embed {
    overflow: hidden;
    text-align: center;
  }
  
  .projects-container .twitter-tweet {
    margin-left: auto;
    margin-right: auto;
  }

  .projects-container .twitter-tweet:before {
    background: transparent;
    width: 0;
  }
  
  .block, .list {
    font-size: 1em;
    font-weight: 300;
    line-height: 1.5em;
  }
  
  .list li {
    font-family: Graphik,sans-serif;
    font-weight: 300;
    margin: 18px 0;
  }

  .projects-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(235px, 1fr));
    column-gap: 10px;
    grid-row-gap: 15px;
    margin-bottom: 132px;
  }
  
  .caption, .image em {
    display: block;
    font-weight: 400;
    font-size: 16px;
    text-align: center;
    margin: 10px 0 18px 0;
  }
  
  .article-body-video {
    margin-bottom: 18px;
  }
  
  .credits-container {
    background-color: black;
    color: white;
  }
  
  .credits {
    line-height: 2em;
    padding: 12px;
    font-weight: 400;
    max-width: 800px;
    margin: 0 auto;
  }
  
  .carousel {
    height: 800px;
  }

  @media only screen and (max-width: ${breakpoints.lg}px) {
    .projects-grid {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(235px, 1fr));
      column-gap: 10px;
      grid-row-gap: 15px;
    }
    
    .projects-container {
      margin: 0 12px;
    }
  }
  
   @media only screen and (max-width: ${breakpoints.md}px) {
    .projects-grid {
      margin: 0 45px;
    }

    .quote {
      height: 2em;
    }
    
    .block-quote {
      gap: 25px;
      font-size: 25px;
      line-height: 125%;
    }
    
    .carousel {
      height: 750px;
    }
  }  
  
  @media only screen and (max-width: ${breakpoints.sm}px) {
  
    .quote {
      height: 1.5em;
    }
    
    .block-quote {
      gap: 15px;
      font-size: 20px;
      line-height: 125%;
    }
    
     .carousel-embed {
      height: 700px;
    }
    
    .vimeo-embed iframe, .youtube-embed iframe{
      height: 200px !important;
    }
  }  
  
  @media only screen and (min-width: ${breakpoints.sm}px) {
    .carousel-embed {
      width: 100%;
      height: 768px;
    }
  }
`
